<template>
  <el-select
    class="template-select"
    :class="{select__block: !inline}"
    :value="value"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    @change="$emit('change', $event)"
    @input="$emit('input', $event)"
  >
    <el-option v-for="item in list" :key="item.id" :value="item.id" :label="item.name"/>
  </el-select>
</template>

<script>
import { fetchAll } from '@/api/template/list'

export default {
  name: 'TemplateSelect',
  props: {
    value: {},
    placeholder: {
      default: '请选择模版'
    },
    inline: {
      default: true
    },
    disabled: {},
    clearable: {
      default: false
    }
  },
  data () {
    return {
      list: []
    }
  },
  methods: {
    random () {
      const value = this.list[Math.round(Math.random() * 100) % this.list.length]
      return value.id
    }
  },
  created () {
    fetchAll()
      .then(data => {
        this.list = data
      })
  }
}
</script>
<style lang="scss" scoped>
.template-select {
  display: block;
}
</style>
